<template>
  <div style="margin: 0px 30px" class="report-15 report-fs" dir="rtl">
    <div style="margin-top: 200px" v-if="pathLogo == m"></div>

    <!-- <div style ="text-align: end;">
        <h3 style ="font-weight: bold;" >HR MANGTAA</h3>
        <p style ="direction: initial;
    text-align: initial;">403, Atlanta Tower, Gulbai Tekra Road,</p>
        <p>Ambawadi ,Ahmedabad - 380009 India</p>
         <p>Phone No.: 079 40099190</p>
        <h3 style ="font-weight: bold;" >
        HEAD COUNT REPORT DETAIL
        </h3>
    </div> -->
    <div class="mlogo">
      <img class="wlogo" :src="pathLogo" />
    </div>
    <h3 style="margin-bottom: 15px" class="text-center fs-head-co">
      {{ fullName }}
    </h3>
    <h3 style="margin-top: 0px" class="text-center fs-head-co">
      {{ shortName }}
    </h3>

    <h3
      style="font-weight: bold; padding-bottom: 40px"
      class="text-center fs-head"
    >
      تقرير بأعداد الموظفين حسب الادارة
    </h3>
    <h5 style="font-weight: bold" class="text-right">
      التاريخ : {{ convert(new Date()) }}
    </h5>
    <div class="md-layout-item md-size-100 mt-25">
      <h4 style="font-weight: bold" class="text-center"></h4>
    </div>
    <section class="body">
      <div style="margin-top: 50px" class="first-section">
        <div class="right">
          <div class="t-body">
            <p style="text-align: center" class="id">ر.م</p>
            <p style="width: 80%; text-align: center">الادارة</p>
            <p style="width: 22%; text-align: center">عدد الموضفين</p>
          </div>

          <div v-for="(item, i) in allData" :key="i" class="t-body">
            <p style="text-align: center" class="id">{{ i + 1 }}</p>
            <p style="width: 80%; text-align: center">{{ item.department }}</p>
            <p style="width: 22%; text-align: center">{{ item.headCount }}</p>
          </div>
        </div>
      </div>

      <div
        style="margin-top: 50px; width: 20%; direction: ltr"
        class="first-section"
      >
        <div class="right">
          <div class="t-body">
            <p style="width: 100%">المجموع</p>
            <p style="width: 70%">{{ total }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import env from "../../../env";

export default {
  props: [
    "allData",
    "fullName",
    "shortName",
    "Days",
    "monthDate",
    "total",
    "pathLogo",
  ],
  data() {
    return {
      m: env.mTop(),
    };
  },
  methods: {
    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return " - ";
        }
        return (
          d.getFullYear() + " - " + (d.getMonth() + 1) + " - " + d.getDate()

          // +
          // " , "
          // +
          // d.getHours() +
          // ":" +
          // d.getMinutes()
        );
      } catch (error) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/Staff_preparation";

.report-fs {
  * {
    font-size: 22px !important;
    font-family: "Cairo", sans-serif !important;
  }
  .fs-head-co {
    font-size: 29px !important;
    font-weight: bold;
  }
  .fs-head {
    font-size: 27px !important;
  }
}
</style>
